module.exports = __webpack_public_path__ + "static/media/chat.6a8e477f.svg";